export const en = {
  downloadTemplate: 'Download Template',
  exportCsv: 'Export CSV',
  importCsv: 'Import CSV',
  bulkActions: 'Bulk Actions',
};
